export default __webpack_public_path__ + "static/sandblasting_painting_ls-2026b1f9fff55ddf7ece0c860b3672b1.jpeg";